// libraries
import React from 'react'
import clsx from 'clsx'

// prop types
interface MaskProps {
    bgColor?: 'white' | 'blue-light' | 'blue' | 'blue-dark' | 'green' | 'yoghurt' | 'yoghurt-dark' | 'new-idea' | 'in-process' | 'rejected' | 'released' | 'other' | string
    spacing?: 'smallest' | 'smaller' | 'small' | 'medium' | 'big'
    children: React.ReactNode
    className?: string
    id?: string
    maskDistortion?: 'none' | 'low'
}

export default function Mask({
    bgColor,
    spacing,
    className,
    children,
    maskDistortion,
    id
}: MaskProps) {

    // custom bg color
    const customBgColor = bgColor && !['white', 'blue-light', 'blue', 'blue-dark', 'green', 'yoghurt', 'yoghurt-dark', 'new-idea', 'in-process', 'rejected', 'released', 'other'].includes(bgColor) ? { backgroundColor: bgColor } : {}

    return (
        <div
            className={clsx(
                'shape-mask',

                // bg colors
                bgColor === 'white' && 'bg-white',
                bgColor === 'blue-light' && 'bg-blue-light',
                bgColor === 'blue' && 'bg-blue',
                bgColor === 'blue-dark' && 'bg-blue-dark',
                bgColor === 'green' && 'bg-green',
                bgColor === 'yoghurt' && 'bg-yoghurt',
                bgColor === 'yoghurt-dark' && 'bg-yoghurt-dark',

                // idea colors
                bgColor === 'new-idea' && 'bg-blue',
                bgColor === 'in-process' && 'bg-yellow',
                bgColor === 'rejected' && 'bg-pink',
                bgColor === 'released' && 'bg-green-bright',
                bgColor === 'other' && 'bg-blue',

                // spacing
                spacing === 'smallest' && 'spacing-smallest',
                spacing === 'smaller' && 'spacing-smaller',
                spacing === 'small' && 'spacing-small',
                spacing === 'medium' && 'spacing-medium',
                spacing === 'big' && 'spacing-big',

                // mask distortion
                maskDistortion && `mask-distortion-${maskDistortion}`,

                className
            )}
            style={customBgColor}
            id={id}
            data-mask
        >
            {children}
        </div>
    )
}